<template>
  <div id="app">
    <NavMenu />
    <router-view />
    <Footer />
  </div>
</template>
<script>
import NavMenu from "../src/components/NavMenu.vue";
import Footer from "../src/components/Footer.vue";
export default {
  components: {
    NavMenu,
    Footer,
  },
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
